const mapFacetsToTealiumFacetValue = (appliedFilters)=>Object.entries(appliedFilters || {}).map(([key, obj])=>obj.value.map((val)=>`${key}=${val}`
        ).join('|')
    ).join('|')
;

export { mapFacetsToTealiumFacetValue };
//# sourceMappingURL=map-facets-to-tealium-facet-value.js.map
